const STATS = [
  { value: "380+", label: "每日新话题" },
  { value: "60+", label: "活跃同好社群" },
  { value: "12", label: "娱乐话题板块" },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[600px] md:min-h-[720px] w-full items-center overflow-hidden bg-foreground-900">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20vector%20illustration%2C%20group%20of%20young%20friends%20gathering%20lively%20around%20a%20round%20table%20chatting%20about%20hot%20topics%20with%20watermelon%20slices%20and%20smartphones%2C%20coral%20red%20and%20fresh%20green%20melon%20accents%20against%20soft%20cream%20background%2C%20floating%20speech%20bubbles%20and%20confetti%20dots%2C%20cozy%20joyful%20community%20atmosphere%2C%20clean%20minimal%20flat%20art%2C%20warm%20inviting%20tone&width=1600&height=900&seq=hero-gua-2026-x1&orientation=landscape')",
        }}
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
          <i className="ri-fire-line text-sm text-secondary-200" aria-hidden="true"></i>
          九色吃瓜群入口开放中 · 组织聚集地直达
        </span>

        <h1 className="mx-auto mt-6 w-full max-w-4xl font-heading text-3xl font-bold leading-snug text-background-50 md:text-5xl md:leading-tight">
          热点瓜田不迷路
          <br className="hidden md:block" />
          找到组织，一起吃瓜蹲后续
        </h1>

        <p className="mx-auto mt-6 w-full max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          九色吃瓜是娱乐话题同好聚集地，聚合新鲜瓜、剧综热梗与话题复盘。
          新瓜预告、后续进度、同好交流都在群里，加进来抱团追更，蹲料不再落单。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          <a
            href="#joinform"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-group-line text-base" aria-hidden="true"></i>
            加入吃瓜群
          </a>
          <a
            href="#guatian"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto"
          >
            先逛今日瓜田
            <i className="ri-arrow-down-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mx-auto mt-14 grid w-full max-w-3xl grid-cols-1 gap-3 sm:grid-cols-3">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-white/15 bg-white/10 px-5 py-5 text-center backdrop-blur-sm"
            >
              <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.value}</p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}